import { useMutation } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";

interface DeleteStandardsSetRelationProps {
  standardsSetId: string;
  relationId: string;
}

export const useDeleteStandardsSetRelation = () => {
  return useMutation<void, Error, DeleteStandardsSetRelationProps>({
    mutationFn: async ({
      standardsSetId,
      relationId,
    }: DeleteStandardsSetRelationProps) => {
      await api().delete(
        `${ApiCatalog.draftContent.endpoint}${standardsSetId}/content-relation/${relationId}/`,
      );
    },
  });
};
